const baseStyle = {
  width: 'auto',
  height: 'auto',
}

export default {
  baseStyle,
  variants: {
    solid: () => ({
      bg: 'bg',
      borderRadius: 'sm',
      px: 2,
      py: 1,
    }),
  },
}
